import { Type } from '@sinclair/typebox';
/**
 * Cursor pagination, not offset pagination.
 *
 * The photo gallery is ordered by capture time and grows at the top as uploads
 * arrive. With OFFSET, inserting a row shifts every later page and the user
 * sees duplicates or gaps while scrolling. A cursor is stable against inserts,
 * and on MariaDB it also stays fast - `OFFSET 50000` still scans 50000 rows.
 */
export const PaginationQuerySchema = Type.Object({
    /** Opaque to clients: an encoded key of the last item on the previous page. */
    cursor: Type.Optional(Type.String({ maxLength: 512 })),
    limit: Type.Optional(Type.Integer({ minimum: 1, maximum: 100, default: 50 })),
});
export function paginatedSchema(item) {
    return Type.Object({
        items: Type.Array(item),
        /** Absent when there are no further pages. */
        nextCursor: Type.Optional(Type.String()),
    });
}
/**
 * Cursors are base64url of an opaque payload. Encoding is not security - it
 * exists so clients treat the value as a token instead of parsing it and
 * depending on our ordering columns, which we would then be unable to change.
 */
export function encodeCursor(payload) {
    return Buffer.from(JSON.stringify(payload), 'utf8').toString('base64url');
}
export function decodeCursor(cursor) {
    try {
        const parsed = JSON.parse(Buffer.from(cursor, 'base64url').toString('utf8'));
        if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed))
            return undefined;
        return parsed;
    }
    catch {
        // A malformed cursor is a client bug or a tampered value; callers treat
        // `undefined` as "start from the beginning" rather than erroring.
        return undefined;
    }
}
//# sourceMappingURL=pagination.js.map